/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './map.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../button/button.component.ngfactory';
import * as i3 from '../../../../../src/app/shared/button/button.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../src/app/shared/map/map.component';
const styles_MapComponent:any[] = [i0.styles];
export const RenderType_MapComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_MapComponent,
    data:{}});
function View_MapComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'div',[['class',
      'form-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class','input-group']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['class','input-group-addon']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['class','glyphicon glyphicon-tags']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,[['geocode',1]],(null as any),
          0,'input',[['class','form-control'],['placeholder','Search...'],['type',
              'text']],(null as any),[[(null as any),'keyup']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keyup' === en)) {
              const pd_0:any = ((<any>_co.onKeyup(i1.ɵnov(_v,5).value)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any)))],(null as any),(null as any));
}
function View_MapComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'admin-button',
      [['tag','primary']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.startRouting()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_ButtonComponent_0,i2.RenderType_ButtonComponent)),i1.ɵdid(638976,(null as any),
      0,i3.ButtonComponent,([] as any[]),{tag:[0,'tag'],outlined:[1,'outlined'],disabled:[2,
          'disabled']},(null as any)),(_l()(),i1.ɵted(0,['Start routing']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'primary';
    const currVal_1:any = true;
    const currVal_2:any = _co.routingStarted;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
export function View_MapComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{div:0}),(_l()(),i1.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_MapComponent_1)),i1.ɵdid(16384,(null as any),
      0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵeld(0,[[1,0],['div',1]],(null as any),0,'div',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),2,'div',[['class','route-control']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_MapComponent_2)),i1.ɵdid(16384,
          (null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any))],(_ck,_v) => {
    var _co:i5.MapComponent = _v.component;
    const currVal_0:any = _co.geocode;
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.route;
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_MapComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-map',([] as any[]),
      (null as any),(null as any),(null as any),View_MapComponent_0,RenderType_MapComponent)),
      i1.ɵdid(4374528,(null as any),0,i5.MapComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const MapComponentNgFactory:i1.ComponentFactory<i5.MapComponent> = i1.ɵccf('admin-map',
    i5.MapComponent,View_MapComponent_Host_0,{lat:'lat',lng:'lng',markers:'markers',
        geocode:'geocode',polyline:'polyline',overlay:'overlay',polygon:'polygon',
        route:'route',routeInterval:'routeInterval',height:'height'},{mapClick:'mapClick',
        mapDragend:'mapDragend',markerClick:'markerClick',instruction:'instruction'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL21hcC9tYXAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL21hcC9tYXAuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvbWFwL21hcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL21hcC9tYXAuY29tcG9uZW50LnRzLk1hcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJmb3JtLWdyb3VwXCIgKm5nSWY9XCJnZW9jb2RlXCI+PGRpdiBjbGFzcz1cImlucHV0LWdyb3VwXCI+PHNwYW4gY2xhc3M9XCJpbnB1dC1ncm91cC1hZGRvblwiPjxzcGFuIGNsYXNzPVwiZ2x5cGhpY29uIGdseXBoaWNvbi10YWdzXCI+PC9zcGFuPiA8L3NwYW4+PGlucHV0IHR5cGU9XCJ0ZXh0XCIgY2xhc3M9XCJmb3JtLWNvbnRyb2xcIiBwbGFjZWhvbGRlcj1cIlNlYXJjaC4uLlwiIChrZXl1cCk9XCJvbktleXVwKGdlb2NvZGUudmFsdWUpXCIgI2dlb2NvZGU+PC9kaXY+PC9kaXY+PGRpdiAjZGl2PjwvZGl2PjxkaXYgY2xhc3M9XCJyb3V0ZS1jb250cm9sXCI+PGFkbWluLWJ1dHRvbiAqbmdJZj1cInJvdXRlXCIgKGNsaWNrKT1cInN0YXJ0Um91dGluZygpXCIgW2Rpc2FibGVkXT1cInJvdXRpbmdTdGFydGVkXCIgdGFnPVwicHJpbWFyeVwiIFtvdXRsaW5lZF09XCJ0cnVlXCI+U3RhcnQgcm91dGluZzwvYWRtaW4tYnV0dG9uPjwvZGl2PiIsIjxhZG1pbi1tYXA+PC9hZG1pbi1tYXA+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBd0M7VUFBQTtNQUF5QjtVQUFBO01BQWdDO1VBQUE7TUFBOEMsc0NBQVE7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUFnRTtjQUFBO2NBQUE7WUFBQTtZQUFoRTtVQUFBOzs7b0JBQWlLO01BQUE7UUFBQTtRQUFBO1FBQTRCO1VBQUE7VUFBQTtRQUFBO1FBQTVCO01BQUEsbUVBQUE7TUFBQTtVQUFBLDRCQUFpSDs7O0lBQWhDO0lBQWM7SUFBMUM7SUFBckQsV0FBaUYsVUFBYyxVQUExQyxTQUFyRDs7OztpREFBeFQ7TUFBQSwyREFBQTtNQUFBO01BQTZRO1VBQUEsMERBQWdCO1VBQUE7VUFBQSwwREFBMkI7VUFBQSx5RUFBQTtVQUFBO1VBQUE7O0lBQWhTO0lBQXhCLFdBQXdCLFNBQXhCO0lBQXNVO0lBQWQsV0FBYyxTQUFkOzs7O29CQ0F4VDtNQUFBO2FBQUE7VUFBQTs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/map/map.component.ngfactory.ts